import { createClient, SupabaseClient } from '@supabase/supabase-js';

const fromEnv = {
  url: process.env.REACT_APP_SUPABASE_URL || '',
  key: process.env.REACT_APP_SUPABASE_ANON_KEY || ''
};
const fromWindow = typeof window !== 'undefined' && (window as any).__SUPABASE_CONFIG__;
const supabaseUrl = fromEnv.url || fromWindow?.url || '';
const supabaseAnonKey = fromEnv.key || fromWindow?.anonKey || '';

const url = supabaseUrl || 'https://placeholder.invalid';
const key = supabaseAnonKey || 'placeholder-key';

let supabaseClientInstance: SupabaseClient | null = null;

export const getSupabaseClient = (): SupabaseClient => {
  if (!supabaseClientInstance) {
    supabaseClientInstance = createClient(url, key);
  }
  return supabaseClientInstance;
};

export const hasSupabaseEnv = (): boolean => !!(supabaseUrl && supabaseAnonKey);

// Export the client for backward compatibility
export const supabaseClient = getSupabaseClient();

// Data types for our Supabase tables
export interface PopulationData {
  location_name: string;
  county: string;
  population: number;
  year: number;
}

export interface HealthInsuranceData {
  location_name: string;
  year: number;
  percent_no_insurance: number;
  margin_of_error: number;
}

export interface PvCostData {
  location_name: string;
  year: number;
  cost_per_watt: number;
  system_size: number;
  sector: string;
}

export interface PvSizeData {
  location_name: string;
  year: number;
  system_size: number;
  sector: string;
  project_count: number;
}

export interface EducationalAttainmentData {
  location_name: string;
  year: number;
  race: string;
  gender: string;
  percent_bachelors_degree?: number;
  bachelors_degree?: number;
  bachelors?: number;
  [key: string]: any; // Allow for other columns
}

export interface VMTData {
  location_name: string;
  year: number;
  mode: string;
  vmt: number;
}
